/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * 
 */
export type EntityStatus = 1 | 2 | 3 | 4 | 5 | 6;

export const EntityStatus = {
    NUMBER_1: 1 as EntityStatus,
    NUMBER_2: 2 as EntityStatus,
    NUMBER_3: 3 as EntityStatus,
    NUMBER_4: 4 as EntityStatus,
    NUMBER_5: 5 as EntityStatus,
    NUMBER_6: 6 as EntityStatus
};
